import React from 'react'
import Skeleton from '../Skeleton'

const HomeSkeleton = () => {
    return (
        <div className="p-4 lg:p-6 max-w-7xl mx-auto overflow-x-hidden">
            {/* Welcome Header */}
            <div className="mb-6 lg:mb-8">
                <Skeleton className="h-8 w-48 mb-2" />
                <Skeleton className="h-4 w-64" />
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6 mb-6 lg:mb-8">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="card p-3 lg:p-6">
                        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                            <div className="mb-2 lg:mb-0 w-full">
                                <Skeleton className="h-4 w-24 mb-2" />
                                <Skeleton className="h-8 w-32" />
                            </div>
                            <Skeleton className="h-8 w-8 rounded-full hidden lg:block" />
                        </div>
                    </div>
                ))}
            </div>

            {/* Quick Payment Categories */}
            <div className="mb-6 lg:mb-8">
                <div className="flex items-center justify-between mb-4 lg:mb-6">
                    <div className="flex items-center space-x-2">
                        <Skeleton className="h-5 w-5" />
                        <Skeleton className="h-6 w-32" />
                    </div>
                    <Skeleton className="h-4 w-24" />
                </div>

                <Skeleton className="h-4 w-96 mb-6 max-w-full" />

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 lg:gap-4">
                    {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="card p-3 lg:p-4 min-h-[144px]">
                            <div className="flex items-start justify-between mb-2">
                                <Skeleton className="w-4 h-4 rounded-full" />
                                <Skeleton className="w-4 h-4" />
                            </div>
                            <Skeleton className="h-5 w-24 mb-2" />
                            <div className="space-y-2">
                                <div className="flex justify-between">
                                    <Skeleton className="h-3 w-12" />
                                    <Skeleton className="h-3 w-16" />
                                </div>
                                <Skeleton className="h-3 w-20" />
                            </div>
                            <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
                                <Skeleton className="h-4 w-16 mx-auto" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Recent Activity */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
                {/* Recent Transactions */}
                <div className="card p-4 lg:p-6">
                    <div className="flex items-center justify-between mb-4">
                        <Skeleton className="h-6 w-40" />
                        <Skeleton className="h-4 w-16" />
                    </div>

                    <div className="space-y-4">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="flex items-center justify-between py-2">
                                <div className="flex items-center space-x-3 flex-1">
                                    <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
                                    <div className="space-y-1 flex-1">
                                        <Skeleton className="h-4 w-32" />
                                        <Skeleton className="h-3 w-24" />
                                    </div>
                                </div>
                                <div className="text-right space-y-1">
                                    <Skeleton className="h-4 w-20 ml-auto" />
                                    <Skeleton className="h-3 w-12 ml-auto" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Top Categories */}
                <div className="card p-4 lg:p-6">
                    <div className="flex items-center justify-between mb-4">
                        <Skeleton className="h-6 w-32" />
                        <Skeleton className="h-4 w-16" />
                    </div>

                    <div className="space-y-4">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="flex items-center justify-between">
                                <div className="flex items-center space-x-3 flex-1">
                                    <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
                                    <div className="space-y-1 flex-1">
                                        <Skeleton className="h-4 w-24" />
                                        <Skeleton className="h-3 w-20" />
                                    </div>
                                </div>
                                <Skeleton className="h-4 w-24" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeSkeleton
